import { PropertyObjectTypesIds, PropertyObjectTypes } from 'ui-forms-components/constants/PropertyObjectTypes';
export const PropertyHelpers = {
  [PropertyObjectTypesIds[PropertyObjectTypes.CONTACT]]: {
    labelColor: 'oz'
  },
  [PropertyObjectTypesIds[PropertyObjectTypes.COMPANY]]: {
    labelColor: 'sorbet'
  },
  [PropertyObjectTypesIds[PropertyObjectTypes.DEAL]]: {
    labelColor: 'lorax'
  },
  [PropertyObjectTypesIds[PropertyObjectTypes.TICKET]]: {
    labelColor: 'norman'
  },
  [PropertyObjectTypesIds[PropertyObjectTypes.SHIPMENT]]: {
    labelColor: 'marigold'
  }
};